export const TermType = {
  EULA: 'eula',
  PRIVACY: 'privacy',
} as const;
